import React from 'react';

import DelayedAccessAlert, {
  Location
} from 'buyside/components/presentation/AccessControl/delayedAccessAlert';
import InfoTable from 'buyside/components/presentation/IdeaShowPage/InfoTable/infoTable';
import ResearchItem, {
  ResearchTypes
} from 'buyside/components/presentation/ResearchItem/researchItem';
import ResearchItemLoading from 'buyside/components/presentation/ResearchItem/researchItemLoading';

import { useWhitePaperShowPageRelatedIdeasQuery } from 'interfaces/graphql-typings';

const relatedResearchStyles = require('buyside/components/presentation/IdeaShowPage/RightSidebar/RelatedIdeas/relatedIdeasStyles.scss');

export type WhitePaperShowPageRelatedResearchProps = {
  id: string;
  canViewUserDetails: boolean;
};

import styles from 'buyside/components/presentation/PostShow/postShowStyles.scss';

const WhitePaperShowPageRelatedResearch: React.FC<WhitePaperShowPageRelatedResearchProps> = ({
  id,
  canViewUserDetails
}) => {
  const { data, loading, error } = useWhitePaperShowPageRelatedIdeasQuery({ variables: { id } });

  if (loading)
    return (
      <InfoTable title="Related Research">
        {(): React.ReactElement => <ResearchItemLoading times={5} narrow />}
      </InfoTable>
    );

  const currentUser = data?.currentUser;

  const relatedIdeas = data?.whitePaper?.relatedIdeas;

  if (error) throw error;

  return (
    <InfoTable title="Related Research">
      {(): React.ReactElement => (
        <>
          {relatedIdeas?.length ? (
            <>
              <DelayedAccessAlert
                id={Location.whitePaperRelatedIdeas}
                customStyles={styles.alertPersistent}
              />
              {relatedIdeas?.map(idea => {
                const ideaAuthor = idea?.user;

                if (!idea || !ideaAuthor) return null;

                const isAuthor = ideaAuthor.id === currentUser?.id;

                return (
                  <div key={idea.id}>
                    <ResearchItem
                      {...idea}
                      researchType={ResearchTypes.IDEA}
                      narrow
                      showUserDetails={canViewUserDetails || isAuthor || idea?.isNonBuyside}
                    />
                  </div>
                );
              })}
            </>
          ) : (
            <div className={relatedResearchStyles.noRelatedResearch}>
              No recommended research available. Check back later.
            </div>
          )}
        </>
      )}
    </InfoTable>
  );
};

export default WhitePaperShowPageRelatedResearch;
